export const TRIGGER_CLICK = 'click';
export const TRIGGER_FOCUS = 'focus';
export const TRIGGER_HOVER = 'hover';
export const TRIGGER_NONE = 'none';
